import {BlockPosition} from "./BlockPosition.js";

export class MusicStructureAnnotationBlock {
    constructor(jsonStructure) {
        this.block_position = new BlockPosition(jsonStructure.block_position);
        this.section_name = jsonStructure.section_name;
        this.rhythmic_style = jsonStructure.rhythmic_style;
        this.harmonic_progression_verbal_description = jsonStructure.harmonic_progression_verbal_description;
        this.section_description = jsonStructure.section_description;
        this.completed = jsonStructure.completed || false;
    }
}